const Coaches = function ($scope, coachInteractor, eventsService) {
  this.$onInit = function () {
    this.filterString = '';
    
    coachInteractor.getCoaches().then(coaches => {
      this.people = coaches;
      $scope.$digest();
    })
  };

  this.getFilteredPeople = function () {
    if (this.filterString.isEmpty || !this.people || this.people.length === 0) {
      return this.people;
    } else {
      return this.people.filter(person => person.name.toUpperCase().indexOf(this.filterString.toUpperCase()) !== -1);
    }
  };

  this.getOverlayText = function (coach) {
    return `Are you sure that you want to stop being coached by ${coach.name}?`;
  };

  this.dischargeCoach = function (coach) {
    return coachInteractor.dischargeCoach(coach).then(() => {
      this.people.splice(this.people.indexOf(coach), 1);
      eventsService.publishSystemMessage(`You are no longer being coached by ${coach.name}`);
      $scope.$digest();
    })
  }
};

export default {
  name: 'coaches',
  obj: {
    controller: Coaches,
    templateUrl: 'components/coaches.html'
  }
}